import { isFinite } from 'lodash';
import {
  usePoundsScaleFactor,
  useWeightMeasurementSystemContext,
} from '../../contexts/WeightMeasurementUnitsContext';
import { localeStringUnit } from '../../constants/measurementUnits.constants';

export const Pounds = ({ quantity, unitDisplay, precision = 2, fallback = 'N/A' }) => {
  const { units } = useWeightMeasurementSystemContext();
  const poundsScaleFactor = usePoundsScaleFactor();

  const options = {
    useGrouping: false,
    minimumFractionDigits: 0,
    maximumFractionDigits: precision,
  };

  if (unitDisplay) {
    options.style = 'unit';
    options.unit = localeStringUnit[units];
    options.unitDisplay = unitDisplay;
  }

  if ((Math.abs(quantity) >= 1e12 || Math.abs(quantity) < Math.pow(10, -precision)) && +quantity !== 0) {
    options.notation = 'scientific';
  }

  if (quantity === null || quantity === '' || !isFinite(+quantity)) return fallback;

  return (quantity * poundsScaleFactor).toLocaleString('en-US', options);
};
